import React from 'react'
import AuthLogin from '../components/Auth/AuthLogin';
export default function Login() {
  return (
   <AuthLogin/>
  )
}
